

import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; 
import { Chart } from 'react-google-charts';
import NoData from "../../NoData";
import ChartLoader from '../../ChartLoader';
import CommanBarTable_Orion from "../CommanBarTable_Orion";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import WaterMark from "../../DashboardMain_Orion/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

let Maxchartdata;
let res_result = [];

function RateOfChargeVehicles_Orion({ apiend, gloablfilter, type, chartnameFCD }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState(chartnameFCD);
  let barcolor = "#83A4CF";

  const appyDataVehicles = (data) => {
    res_result = [];
    res_result = data;

    let responce = {
      "10": 0,
      "20": 0,
      "30": 0,
      "40": 0,
      "50": 0,
      "60": 0,
      "70": 0,
      ">70": 0,
    };

    if (res_result.length !== 0) {
      SetApiResponce(res_result);

      res_result.forEach(d => {
        const value = d.median_roc.values["50.0"];
        if (value != null) {
          if (value > 0 && value <= 10) responce["10"]++;
          else if (value > 10 && value <= 20) responce["20"]++;
          else if (value > 20 && value <= 30) responce["30"]++;
          else if (value > 30 && value <= 40) responce["40"]++;
          else if (value > 40 && value <= 50) responce["50"]++;
          else if (value > 50 && value <= 60) responce["60"]++;
          else if (value > 60 && value <= 70) responce["70"]++;
          else if (value > 70) responce[">70"]++;
        }
      });

      const loop_keys = ["10", "20", "30", "40", "50", "60", "70", ">70"];
      let countcheck = 0;
      for (const key in responce) {
        if (responce[key] > 0) countcheck++;
      }

      let res_result_final = [["Element", "Count", { role: "style" }]];
      loop_keys.forEach(x => {
        if (countcheck) res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      });

      Maxchartdata = {
        labels: loop_keys,
        datasets: [
          {
            label: "SoC(%) per Hour",
            data: Object.values(responce),
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };

      setChartData(res_result_final);
    } else {
      setChartData([]);
    }
  };

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: { color: 'white' },
        title: { display: true, text: 'SoC(%) per Hour' },
        suggestedMin: 0,
        ticks: { autoSkip: false, maxRotation: 0, minRotation: 0 },
      },
      y: {
        grid: { color: 'white' },
        title: { display: true, text: 'Vehicle Count' },
        suggestedMin: 0,
      },
    },
    plugins: { legend: { display: false } }
  };

  const options = {
    hAxis: {
      gridlines: { color: 'transparent' },
      title: 'SoC(%) per Hour',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
    },
    vAxis: {
      gridlines: { color: 'transparent' },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: { 0: { color: "#83A4CF" } },
  };

  useEffect(() => {
    barcolor = "#83A4CF";
    SetChartName("Rate of charge");
    fetchData({ url: API_URL_MAIN + "orion_charging_analysis/" + apiend, body: { filterdata: gloablfilter } }, appyDataVehicles);
  }, [gloablfilter, type]);

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {isLoading ? <ChartLoader /> : (chartdata.length > 1 ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" /> : <NoData />)}
            </div>
          </div>
        </div>
      </div>

      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"}> <BsZoomIn /> </strong>
      <WaterMark />

      {isLoading ? <ChartLoader /> : (chartdata.length > 1 ? <Chart chartType="ColumnChart" width="100%" height="200px" data={chartdata} options={options} chartEvents={[
        {
          eventName: 'select',
          callback: ({ chartWrapper }) => {
            const chart = chartWrapper.getChart();
            const selection = chart.getSelection();
            if (selection.length === 1) {
              const [selectedItem] = selection;
              const { row } = selectedItem;
              const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
              const count = chartWrapper.getDataTable().Wf[row].c[1].v;

              let filtered_temp = [];
              if (count !== 0) {
                filtered_temp = apiresponce.filter(x => {
                  if (x.median_roc.values["50.0"] <= barvalue && x.median_roc.values["50.0"] > barvalue - 10) return x;
                  else if (x.median_roc.values["50.0"] > 70 && barvalue === ">70") return x;
                  else if (x.median_roc.values["50.0"] <= 10 && barvalue === "10") return x;
                });

                function compareObjects(object1, object2) {
                  const obj1 = object1.median_roc.values["50.0"];
                  const obj2 = object2.median_roc.values["50.0"];
                  return obj2 - obj1;
                }

                filtered_temp.sort(compareObjects);
                SetfilteredData(prestate => filtered_temp);
                window.$('#exampleModal__' + apiend).modal('show');
              }
            }
          }
        }
      ]} /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <CommanBarTable_Orion data={filteredData} tabDataKey={"median_roc"} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RateOfChargeVehicles_Orion;
